import { render, staticRenderFns } from "./transfer_bank.vue?vue&type=template&id=48e26db4&scoped=true"
import script from "./transfer_bank.vue?vue&type=script&lang=js"
export * from "./transfer_bank.vue?vue&type=script&lang=js"
import style0 from "./transfer_bank.vue?vue&type=style&index=0&id=48e26db4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e26db4",
  null
  
)

export default component.exports